import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';

export const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <WebLayout>
      <div className="bg-[#26C4FF] p-6 md:p-12 mt-8 mb-8 md:px-40 text-white text-center">
        <h1 className="text-4xl md:text-7xl font-black">Privacy Policy</h1>
      </div>

      <div className="max-w-5xl mx-auto p-6 space-y-10 text-gray-800">
        <section>
          <h2 className="text-2xl font-bold mb-3">1. Introduction</h2>
          <p>
            Welcome to Wire24. Your privacy is important to us. This Privacy Policy outlines how we
            collect, use, and protect your information.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">2. Information We Collect</h2>
          <p>
            We collect personal information such as your name, email, phone number, and transaction
            details to provide our services effectively.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">3. How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>To provide, maintain, and improve our services.</li>
            <li>To comply with legal and regulatory requirements.</li>
            <li>To communicate with you regarding updates and transactions.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">4. Sharing of Information</h2>
          <p>
            We do not sell your personal data. We may share your information with trusted third
            parties for compliance, fraud prevention, and service fulfillment.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">5. Security Measures</h2>
          <p>
            We use industry-standard security measures to protect your personal information from
            unauthorized access and breaches.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">6. Your Rights</h2>
          <p>
            You have the right to access, update, or request deletion of your personal information.
            Contact us for assistance.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">7. Changes to This Policy</h2>
          <p>
            Wire24 may update this Privacy Policy. Continued use of our services implies acceptance
            of any updates.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3">8. Contact Us</h2>
          <p>
            If you have any questions regarding this Privacy Policy, please contact us at{' '}
            <span className="text-blue-500">privacy@wire24.co</span>.
          </p>
        </section>
      </div>

      <div className="bg-gray-100 p-6 mt-12 text-center text-gray-600">
        <p>Last updated on 10th February, 2025.</p>
      </div>
    </WebLayout>
  );
};
